import { WorkshopService } from 'api/generated/services/WorkshopService';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useWorkshopByIdQueryKey = 'useWorkshopByIdQueryVHCRecord';

export const useWorkshopByIdQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  filter: { soHeaderId?: number },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WorkshopService.getWorkshop1>>,
      QueryError,
      Awaited<ReturnType<typeof WorkshopService.getWorkshop1>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useWorkshopByIdQueryKey, ...(queryKey ?? [{ ...filter }])],
    () => WorkshopService.getWorkshop1(filter.soHeaderId!),
    options
  );
